import { Form } from 'antd';
import React from 'react';

import RichTextInput from 'components/RichTextInput';
import TranslationTabs from 'components/TranslationTabs';

const TranslationInput = ({ name, primary, translations, onAddTranslation }) => (
  <TranslationTabs
    primary={primary}
    translations={translations}
    onAddTranslation={onAddTranslation}
    primaryContent={(
      <Form.Item name={[...name, primary.id]}>
        <RichTextInput />
      </Form.Item>
    )}
    translationsContent={translations.map((translation) => (
      <Form.Item name={[...name, translation.id]}>
        <RichTextInput />
      </Form.Item>
    ))}
  />
);

export default TranslationInput;
